module.exports = __webpack_public_path__ + "img/erin-patterson15.b0a4eeb1.png";